// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.header-inner[data-v-7ba5bd90] {\n  margin-bottom: 1%;\n}\n.homeTitle div[data-v-7ba5bd90]:last-child {\n  margin-left: auto;\n}\n.system-title[data-v-7ba5bd90] {\n  text-transform: lowercase;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
